var e = /* @__PURE__ */ ((t) => (t.Horizontal = "horizontal", t.Vertical = "vertical", t))(e || {}), r = /* @__PURE__ */ ((t) => (t.Accent = "accent", t.Success = "success", t))(r || {}), a = /* @__PURE__ */ ((t) => (t.First = "first", t.Last = "last", t))(a || {});
const c = {
  accent: {
    progressBar: {
      on: {
        bar: "border-static-accent-hi",
        after: "after:border-static-accent-hi",
        before: "before:border-static-accent-hi"
      },
      off: {
        bar: "border-static-default-low",
        after: "after:border-static-default-low",
        before: "before:border-static-default-low"
      }
    },
    icon: "text-static-accent-hi",
    color: "text-static-default-hi"
  },
  success: {
    progressBar: {
      on: {
        bar: "border-static-success-hi",
        after: "after:border-static-success-hi",
        before: "before:border-static-success-hi"
      },
      off: {
        bar: "border-static-default-low",
        after: "after:border-static-default-low",
        before: "before:border-static-default-low"
      }
    },
    icon: "text-static-success-hi",
    color: "text-static-default-hi"
  }
};
export {
  c as ColorsByVariant,
  e as OrientationsEnum,
  r as ProgressBarColorsEnum,
  a as StartWithsEnum
};
